import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ fontSizes }: Theme) => ({
  error: {
    fontSize: fontSizes.xs,
  },
}));
